import { ITopolPageProps } from '@/types/TopolPageProps/TopolPageProps';
import { usePage } from '@inertiajs/vue3';
import { computed } from 'vue';

/** Roles granted the `create` team permission in JetstreamServiceProvider. */
const CAN_WRITE_ROLES = ['owner', 'admin', 'editor'];

export default () => {
    const inertiaProps = usePage<ITopolPageProps>();

    const isViewer = computed(() => {
        return inertiaProps.props.team_role?.key === 'viewer';
    });

    const isEditor = computed(() => {
        return inertiaProps.props.team_role?.key === 'editor';
    });

    const isAdmin = computed(() => {
        return inertiaProps.props.team_role?.key === 'admin';
    });

    const isOwner = computed(() => {
        return inertiaProps.props.team_role?.key === 'owner';
    });
    //TODO member
    const isEditorAndUp = computed(() => {
        return CAN_WRITE_ROLES.includes(inertiaProps.props.team_role?.key ?? '');
    });

    /**
     * Mirrors IntegrationPolicy / Jetstream's `create` team permission. Roles
     * without it get a 403 from the server, so the UI must not offer the action.
     */
    const canCreate = isEditorAndUp;

    return {
        isViewer,
        isEditor,
        isAdmin,
        isOwner,
        isEditorAndUp,
        canCreate,
    };
};
